import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setLogout, selectUserData } from "features/user/userSlice";
import { Col, Row } from "antd";
import { Typography } from "antd";
import { useNavigate } from "react-router-dom";
import { Image } from "antd";
import { setRoutes } from "features/nav/routesSlice";
import { RequireAuth } from "components/auth";
import { getMenus } from "service/menu";

const { Title } = Typography;
const MODULES = [
  {
    ASSET_VIEWER: {
      img: "/static/images/home/asset.png",
      title: "Asset Viewer",
      url: "/asset-viewer",
      menu: null,
    },
  },
  {
    WELL_VIEWER: {
      img: "/static/images/home/wv.png",
      title: "Well Viewer",
      url: "/well-viewer",
      menu: null,
    },
  },
  {
    PRODUCTION_ANALYZER: {
      img: "/static/images/home/pa.png",
      title: "Production Analyzer",
      url: "/decline_analysis/analyzer/",
      menu: null,
    },
  },
  {
    DATA_MANAGER: {
      img: "/static/images/home/dm.png",
      title: "Data Manager",
      url: "/petrophysics_input/",
      menu: null,
    },
  },
  {
    WELL_PLANNER: {
      img: "/static/images/home/wp.png",
      title: "Well Planner",
      url: "well_planner/",
      menu: null,
    },
  },
  {
    COMPLETION_OPTIMIZER: {
      img: "/static/images/home/co.png",
      title: "Completion Optimizer",
      url: "/completion_optimizer/",
      menu: null,
    },
  },
];
const ModuleBlock = (props) => {
  const [size] = useState("large");
  const { img, title, url, menu } = props;
  let navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <div
      style={{
        width: "100%",
        height: "15vh",
        alignItems: "left",
        alignContent: "start",
        textAlign: "left",
        verticalAlign: "middle",
      }}
      onClick={() => {
        if (menu) {
          dispatch(setRoutes(menu.routes||[]));
          navigate(url);
        }
      }}
      size={size}
    >
      <Row style={{ alignItems: "center", cursor: "pointer" }}>
        <Image
          width={120}
          style={{ marginRight: "10px" }}
          src={img || "/images/project/Group2.png"}
          preview={false}
        />
        <Title type="secondary" style={{ color: "#ccc", marginLeft: "12px" }}>
          {title}
        </Title>
      </Row>
    </div>
  );
};
const Homepage = (props) => {
  const userData = useSelector(selectUserData);
  const dispatch = useDispatch();
  const [appMenus, setAppMenus] = useState(null);

  function getUserName() {
    if (userData == null) {
      return "";
    }

    return userData.first_name + " " + userData.last_name;
  }

  function getAvatarUrl() {
    // userData.photo gets populated either from the login response or after the
    // user uploads one via /profile. Falls back to the static default avatar.
    const photo = userData?.photo;
    if (photo && photo !== "photo/url" && photo.startsWith("/")) {
      return photo; // server-relative URL like /media/photos_1/avatar.jpg
    }
    if (photo && /^https?:\/\//.test(photo)) {
      return photo;
    }
    return "/static/images/users/default-avatar.jpg";
  }

  useEffect(() => {
    getMenus((data) => {
      console.log("data", data);
      for (const appMenu of data) {
        const module = MODULES.find((mod) => Object.keys(mod)[0] === appMenu.name);
        module[appMenu.name].menu = {
          routes: appMenu.menus,
        }
      }
      console.log("MODULES", MODULES);
      setAppMenus(MODULES);
    }, (error) => {});
  }, []);

  return (
    <RequireAuth>
      <div style={{ width: "100%", height: "70px" }}>
        <div className="navbar-header" style={{ backgroundColor: "#003" }}>
          <div style={{ fontSize: "24px", marginLeft: "20px" }}>
            <img
              style={{ height: "6em" }}
              src="/static/images/logo-text2.png"
              alt="logo"
            />
          </div>
          <div className="d-flex align-items-center">
            <div
              className="dropdown d-inline-block"
              style={{ marginRight: "30px" }}
            >
              <button
                type="button"
                className="btn header-item waves-effect"
                id="page-header-user-dropdown"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <img
                  className="rounded-circle header-profile-user"
                  src={getAvatarUrl()}
                  alt="Header Avatar"
                  onError={(e) => {
                    e.currentTarget.src = "/static/images/users/default-avatar.jpg";
                  }}
                />
                <span className="d-none d-xl-inline-block ms-1 fw-medium">
                  {getUserName()}
                </span>
                <i className="uil-angle-down d-none d-xl-inline-block"></i>
              </button>
              <div className="dropdown-menu dropdown-menu-end">
                <Link className="dropdown-item" to="/profile/">
                  <i className="uil uil-user-circle align-middle text-muted me-1"></i>{" "}
                  <span className="align-middle">View Profile</span>
                </Link>
                <Link className="dropdown-item" to="/account/change_password/">
                  <i className="align-middle text-muted me-1 mdi mdi-key"></i>{" "}
                  <span className="align-middle">Change Password</span>
                </Link>
                <div className="dropdown-divider"></div>
                <Link
                  className="dropdown-item text-danger"
                  onClick={() => {
                    dispatch(setLogout(null));
                  }}
                  to="/logout/"
                >
                  <i className="align-middle me-1 text-danger mdi mdi-logout-variant"></i>
                  <span className="align-middle">Log Out</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="layout-wrapper">
        <main
          style={{
            width: "80%",
            marginLeft: "10%",
            marginTop: "18vh",
            alignItems: "start",
          }}
        >
          <Row gutter={[32, 48]}>
            {appMenus && appMenus.map((mod, index) => {
              let item = mod[Object.keys(mod)[0]];
              return (
                <Col key={index} className="gutter-row" span={12}>
                  <ModuleBlock
                    url={item.url}
                    img={item.img}
                    title={item.title}
                    menu={item.menu}
                  />
                </Col>
              );
            })}
          </Row>
          <footer className="footer"></footer>
        </main>
      </div>
    </RequireAuth>
  );
};

export default Homepage;
